import { Box, Paper, Slider, Stack, Typography } from "@mui/material"
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import React from "react";
import { roundNum } from "../../../../../helpers";
import { getTheme } from "../../../../../utils/theme";
import PropTypes from 'prop-types';

const TinyText = styled(Typography)({
  fontSize: '0.75rem',
  opacity: 0.6,
  fontWeight: 500,
  letterSpacing: 0.2,
});

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(10, 25, 41)' : '#fff',
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(132 135 154 / 0%), 0 2px 3px rgb(132 135 154 / 0%)',
  border: theme.palette.mode === 'dark' ? '1px solid rgb(19, 47, 76)' : 0,
  '& .Item-Head': {
    background: '#fbfbfc !important',
    borderBottom: '1px solid #eae9ee',
    // borderTop: '1px solid #eae9ee',
    padding: '0 8px 0 8px',
    borderRadius: 0,
    '& a': {
      textDecoration: 'none',
    },
    '& .option-title': {
      fontWeight: 500,
      color: '#13113c',
      fontSize: '.875rem',
    }
  },
  '& .Item-Body': {
    padding: theme.spacing(2),
    paddingTop: 0,
  }
}));

const FiveTwoWeek_Tooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.mode === 'dark' ? '#fbfbfc' : '#f2f2f2',
    // backgroundColor: '#e7ecf2',
    // color: theme.palette.text.color.white,
    boxShadow: theme.palette.mode === 'dark' ? 0 : '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
    color: '#000000a1',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: theme.palette.mode === 'dark' ? '1px solid rgb(19, 47, 76)' : 0,
  },
}));

const FiveTwoRange = ({ info, data, realtime_stock_data }) => {
  // const { realtime_stock_data, } = info || {}
  const { open_high_low } = data || {};
  const yearHighLow = open_high_low && open_high_low.length > 0 ? open_high_low[0] : {};
  const theme = getTheme();

  const ValueLabelComponent = (props) => {
    const { children, value } = props;

    return (
      <FiveTwoWeek_Tooltip
        enterTouchDelay={0}
        followCursor
        disableInteractive
        placement="bottom-start"
        title={
          <>
            <Typography variant="body2" display="block" color="inherit" gutterBottom>52-week range:</Typography>
            <u>{'The lowest'}</u>&nbsp;
            <>{"and"}</>&nbsp;
            <u>{'highest price'}</u>&nbsp;
            <>{`at which ${info?.ticker} has traded during the previous`}</>&nbsp;
            <b>{'52 weeks'}</b>.
          </>
        }
      >
        {children}
      </FiveTwoWeek_Tooltip>
    );
  }

  ValueLabelComponent.propTypes = {
    children: PropTypes.element.isRequired,
    value: PropTypes.number.isRequired,
  };

  return (
    <>
      {realtime_stock_data && realtime_stock_data.length > 0 && roundNum(yearHighLow.year_high) &&
        <Item>
          <Box sx={{}}>
            <Box className="Item-Head" component="div" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', m: 0, cursor: 'pointer' }}>
              <Typography component="h4" className="option-title" sx={{
                fontSize: '.875rem !important',
                color: '#70708F !important'
              }}>
                52 Week Range
              </Typography>
            </Box>
            <Box className="Item-Body" component="div">
              <Stack spacing={1.2} direction="row" sx={{ mt: 3.3, mb: 1, }} alignItems="center">
                {/* <TinyText>(Low)&nbsp;{roundNum(yearHighLow.year_low)}</TinyText> */}
                <TinyText>{roundNum(yearHighLow.year_low)}</TinyText>
                <Slider
                  valueLabelDisplay="auto"
                  components={{
                    ValueLabel: ValueLabelComponent,
                  }}
                  aria-label="52-week"
                  size="small"
                  track={false}
                  value={roundNum(realtime_stock_data[0].price)}
                  step={1}
                  // defaultValue={[roundNum(yearHighLow.year_low), roundNum(yearHighLow.year_high)]}
                  min={roundNum(yearHighLow.year_low)}
                  max={roundNum(yearHighLow.year_high)}
                  onChange={e => e.preventDefault()}
                  // onChange={(_, value) => setPosition(value)}
                  sx={{
                    // color: theme.palette.mode === 'dark' ? '#fff' : 'rgba(0,0,0,0.87)',
                    color: 'text.link',
                    height: 4,
                    '& .MuiSlider-markLabel': {
                      fontSize: '0.75rem',
                      fontWeight: 500,
                      color: 'text.link',
                      letterSpacing: 0.2,
                      top: '-15px',
                    },
                    '& .MuiSlider-thumb': {
                      width: 8,
                      height: 8,
                      transition: '0.3s cubic-bezier(.47,1.64,.41,.8)',
                      // '&:before': {
                      //   boxShadow: '0 2px 12px 0 rgba(0,0,0,0.4)',
                      // },
                      boxShadow: `0px 0px 0px 8px ${theme.palette.mode === 'dark'
                        ? 'rgb(255 255 255 / 16%)'
                        : 'rgb(23 76 134 / 16%)'
                        }`,
                      '&:hover, &.Mui-focusVisible': {
                        // boxShadow: `0px 0px 0px 8px ${theme.palette.mode === 'dark'
                        //   ? 'rgb(255 255 255 / 16%)'
                        //   : 'rgb(0 0 0 / 16%)'
                        //   }`,
                        width: 12,
                        height: 12,
                      },
                      '&.Mui-active': {
                        width: 20,
                        height: 20,
                      },
                    },
                    '& .MuiSlider-rail': {
                      opacity: 0.28,
                    },
                  }}
                  marks={[
                    {
                      value: roundNum(realtime_stock_data[0].price),
                      label: `${roundNum(realtime_stock_data[0].price)} (Now)`,
                    },
                  ]}
                />
                {/* <TinyText>{`${roundNum(yearHighLow.year_high)}`}&nbsp;(High)</TinyText> */}
                <TinyText>{`${roundNum(yearHighLow.year_high)}`}</TinyText>
              </Stack>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  mt: -2,
                }}
              >
                <TinyText>{`(Low)`}</TinyText>
                <TinyText>{`(High)`}</TinyText>
              </Box>
            </Box>
          </Box>
        </Item>
      }
    </>
  )
}

export default React.memo(FiveTwoRange)
